<script lang="ts">
  import clsx from 'clsx';
  import { Text } from '@athena-lib/Text';
  import { type ParagraphProps } from './types';
  const { children, class: className, ...props }: ParagraphProps = $props();
</script>

<Text class={clsx('mb-3', 'last-of-type:mb-0', className)} {...props} element="p">
  {#if children}
    {@render children()}
  {/if}
</Text>
